import { nanoid } from "@reduxjs/toolkit";

export default function ncNanoId(prefix = "dz_insights_") {
  return prefix + nanoid() + "_";
}
